import React from 'react';

import Typography from '../../library/typography/typography';

import { useMessage } from '../../shared/hooks/hooks';

import { isVirtualAssortmentParentProduct } from '../../shared/utils/product/product';

import { Maybe, ProductData } from '../../shared/types/graphql-types';
import { VIRTUAL_ASSORTMENT_PARENT_BRANDS_VARY } from '../../shared/constants/messages';

import './parent-product-message.scss';

export interface ParentProductMessageProps {
  className?: string;
  product?: Maybe<ProductData>;
}

function ParentProductMessage(props: ParentProductMessageProps) {
  const { className, product } = props;
  const isVirtualAssortmentParent = isVirtualAssortmentParentProduct(product);
  const messages = useMessage([VIRTUAL_ASSORTMENT_PARENT_BRANDS_VARY]);

  if (!isVirtualAssortmentParent) {
    return null;
  }

  return (
    <Typography className={className} styleName="copy">
      {messages?.VIRTUAL_ASSORTMENT_PARENT_BRANDS_VARY ||
        'Brands may vary based on availability.'}
    </Typography>
  );
}

export default ParentProductMessage;
